import React, { forwardRef, lazy, Suspense, useEffect, useState } from "react"

/**
 * Client-only wrapper around @lottiefiles/react-lottie-player.
 *
 * The package bundles lottie-web, which initialises itself whenever a global
 * `navigator` exists and then calls `document.createElement`. Node 21+ defines
 * `globalThis.navigator`, so importing the package into the SSR bundle throws
 * "document is not defined" during `gatsby build`. Importing it lazily after
 * mount keeps it out of server rendering entirely. The server and the first
 * client render both produce nothing, so there is no hydration mismatch.
 */
const LazyPlayer = lazy(() => import("@lottiefiles/react-lottie-player").then(module => ({ default: module.Player })))

const LottiePlayer = forwardRef(function LottiePlayer(props, ref) {
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
	}, [])

	if (!mounted) {
		return null
	}

	return (
		<Suspense fallback={null}>
			<LazyPlayer ref={ref} {...props} />
		</Suspense>
	)
})

export default LottiePlayer
